<div class="row g-0 services-nav-card">
  <!-- Close button -->
  <button type="button" class="btn-close position-absolute m-3" aria-label="Close" (click)="closeCard()">
  </button>

  <!-- Left Side - Header Text -->
  <div class="col-md-3 p-4 services-nav-bg d-flex flex-column justify-content-start">
    <h2 class="text-orange fs-4 fw-bold mb-3">Capabilities Built Specifically For Your Business</h2>
    <p class="text-gray small mb-0">
      We're proud to share that Kalpita Technology has helped featured among the best outsourcing service providers, a
      recognition that highlights our commitment to delivering exceptional service, innovation, and value to our
      clients.
    </p>
  </div>

  <!-- Right Side - Grid -->
  <div class="col-md-9 p-4 bg-white">
    <div class="row">

      <!-- Services Block (2 cols) -->
      <div class="col-12 col-md-6">
        <div class="text-left mb-3">
          <h5 class="fw-bold text-dark">Services</h5>
        </div>
        <div class="row">
          <div class="col-6">
            <ul class="list-unstyled">
              <li><a routerLink="/company-services/custom-software-development" class="dropdown-item"
                  (click)="closeCard()">Custom Software Development</a></li>
              <li><a routerLink="/company-services/mobile-app-development" class="dropdown-item"
                  (click)="closeCard()">Mobile App Development</a></li>
              <li><a routerLink="/company-services/web-development" class="dropdown-item"
                  (click)="closeCard()">Web Development</a></li>
              <li><a routerLink="/company-services/ui-ux-design" class="dropdown-item"
                  (click)="closeCard()">UI/UX Design</a></li>
              <li><a routerLink="/company-services/it-consulting" class="dropdown-item"
                  (click)="closeCard()">IT Consulting</a></li>
            </ul>
          </div>
          <div class="col-6">
            <ul class="list-unstyled">
              <li><a routerLink="/company-services/digital-marketing" class="dropdown-item"
                  (click)="closeCard()">Digital Marketing</a></li>
              <li><a routerLink="/company-services/testing-qa" class="dropdown-item"
                  (click)="closeCard()">Testing & QA</a></li>
              <!-- <li><a routerLink="/company-services/software-development" class="dropdown-item"
                  (click)="closeCard()">IT Consulting</a></li> -->
              <li><a routerLink="/company-services/ai-as-a-service" class="dropdown-item"
                  (click)="closeCard()">AI as a Service</a></li>
              <li><a routerLink="/company-services/data-engineering" class="dropdown-item"
                  (click)="closeCard()">Data Engineering</a></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Industries Block (2 cols) -->
      <div class="col-12 col-md-6">
        <div class="text-left mb-3">
          <h5 class="fw-bold text-dark">Industries</h5>
        </div>
        <div class="row">
          <div class="col-6">
            <ul class="list-unstyled">
              <li><a routerLink="/industries/insurtech" class="dropdown-item"
                  (click)="closeCard()">Insurtech</a></li>
              <li><a routerLink="/industries/healthtech" class="dropdown-item"
                  (click)="closeCard()">Healthtech</a></li>
              <li><a routerLink="/industries/fintech" class="dropdown-item"
                  (click)="closeCard()">Fintech</a></li>
              <li><a routerLink="/industries/hitech" class="dropdown-item"
                  (click)="closeCard()">Hi-Tech</a></li>
              <li><a routerLink="/industries/ecommerce" class="dropdown-item"
                  (click)="closeCard()">E-commerce</a></li>
              <li><a routerLink="/industries/media-entertainment" class="dropdown-item"
                  (click)="closeCard()">Media & Entertainment</a></li>
              <li><a routerLink="/industries/edtech" class="dropdown-item"
                  (click)="closeCard()">Ed-Tech</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>